// 后台请求
export const BasePath = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BasePath : '/';
export const FileBaseFolder = process.env.VUE_APP_Platform === 'win' ? 'E:\\TSSWCFServices\\FileBaseFolder\\' : '/TSSWCFServices/FileBaseFolder/';
export const CommonServiceUrl = BasePath + 'Services/CommonService.svc/';
export const UserServiceUrl = BasePath + 'Services/AuthenticationService.svc/';
export const FileOperationServiceUrl = BasePath + 'Services/FileOperationService.svc/';
export const QuantStudioServiceUrl = BasePath + 'Services/QuantStudioService.svc/';

// 普惠环境目录不一样
const path = process.env.VUE_APP_CUSTOMER === 'puhui' ? '/QuickDealSrc/' : BasePath;
export const TaskProcessIndicatorUrl = path+'TaskProcessEngine/www/taskprocessindicator/taskprocessindicator.html';
export const SessionManagementServiceUrl = path+'TaskProcessEngine/SessionManagementService.svc/jsAccessEP/';
export const TaskProcessServiceUrl = path+'TaskProcessEngine/TaskProcessServiceRest.svc/jsAccessEP/';

// web 页面以及文件
export const FileBaseFolderUrl = BasePath + 'FileBaseFolder/';``
// 导出产品文件路径
export const CashFlowEngineUrl = BasePath + 'CashFlowEngine/'; // CashFlowEngine/UITaskStudio/CashFLowDisplayer.html?appDomain='
export const Client = process.env.VUE_APP_Platform === 'win' ? 'E:\\Client\\' : '/Client/'
